module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-00.1.240d5ffc.jpg";